// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import UpOutlinedSvg from "@ant-design/icons-svg/lib/asn/UpOutlined";
import AntdIcon from "../components/AntdIcon";
const UpOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: UpOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    UpOutlined.displayName = "UpOutlined";
}
export default /*#__PURE__*/ React.forwardRef(UpOutlined);
